import React, { useContext } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import styles from './LoadModal.module.scss';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import LoadingContext from '../../../context/loadingContext/LoadingContext';
import {
  MUTATION_KEYS_TO_MONITOR,
  QUERY_KEYS_TO_MONITOR,
} from '../../../queries/queryKeys';

const LoadingIcon = <LoadingOutlined style={{ fontSize: 48 }} spin />;

const LoadModal = () => {
  const { isLoading } = useContext(LoadingContext);
  const isFetching = useIsFetching({
    predicate: (query) => {
      const key = query.queryKey[0];
      return QUERY_KEYS_TO_MONITOR.includes(key as string);
    },
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => {
      const key = mutation.options.mutationKey?.[0];

      return MUTATION_KEYS_TO_MONITOR.includes(key as string) || false;
    },
  });

  if (!isLoading && isFetching === 0 && isMutating === 0) return null;

  return (
    <div className={`load-modal ${styles.spinWrapper}`}>
      <div className={styles.loadingIconContainer}>
        <Spin
          size='large'
          indicator={LoadingIcon}
          spinning={true}
          className={styles.spinner}
        />
      </div>
    </div>
  );
};
export default LoadModal;
